module.exports = __webpack_public_path__ + "static/media/profile-picture.782adc2b.png";